export enum NotificationMethod {
  Email = 1,
  Banner = 2,
  Sms = 3
}
